import { useMutation } from "react-query";
import axios from "axios";
import companyController from "controllers/companyController.jsx";
import tagController from "controllers/tagController.jsx";

const createCompany = async ({ company }) => {
  const { data: createdCompany } = await axios.post(
    `/api/v2/companies`,
    company
  );

  return createdCompany;
};

export default function useCreateCompany() {

  return useMutation(async ({ company }) => await createCompany({ company }));
}
